import { jsx as _jsx } from "react/jsx-runtime";
import { ChartDetail } from '../../components/chart_detail/chart_detail.component';
const ChartDetailPage = () => {
    return _jsx(ChartDetail, {});
};
export default ChartDetailPage;
